const runtimeConfig = window.__WAF_CONFIG__ ?? {};

function sanitizeUrl(raw: string | undefined): string {
  if (!raw) return '';
  try {
    const parsed = new URL(raw);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      console.error('[env] URL rejected — invalid protocol:', raw);
      return '';
    }
    return raw;
  } catch {
    console.error('[env] URL rejected — not a valid URL:', raw);
    return '';
  }
}

const resolvedApiBaseUrl =
  sanitizeUrl(runtimeConfig.apiBaseUrl) ||
  sanitizeUrl(import.meta.env.VITE_API_BASE_URL) ||
  'http://localhost:8001';

if (import.meta.env.PROD && resolvedApiBaseUrl === 'http://localhost:8001') {
  console.error('[env] VITE_API_BASE_URL is not configured. Using localhost fallback in production.');
}

export function joinApiUrl(baseUrl: string, path: string): string {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const trimmedBase = baseUrl.replace(/\/+$/, '');
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return trimmedBase + suffix;
}

export const env = {
  appName: runtimeConfig.appName || import.meta.env.VITE_APP_NAME || 'White&Flex CRM',
  apiBaseUrl: resolvedApiBaseUrl,
  openApiUrl:
    sanitizeUrl(runtimeConfig.openApiUrl) ||
    sanitizeUrl(import.meta.env.VITE_OPENAPI_URL) ||
    'http://localhost:8001/openapi.json',
  sentryDsn: runtimeConfig.sentryDsn || import.meta.env.VITE_SENTRY_DSN || '',
  sentryTracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.2'),
};
